import { REQUEST_EXPIRATION_OPTION_HOURS, REQUEST_EXPIRATION_OPTIONS } from '@shared/expiration_options';

export const CONTENT_TYPES = {
  VIDEO: 'video',
  FILE: 'file',
  IMAGE: 'image',
} as const;

export type ContentType = (typeof CONTENT_TYPES)[keyof typeof CONTENT_TYPES];

export const CONTENT_TYPE_OPTIONS = [
  { label: 'Video', value: CONTENT_TYPES.VIDEO },
  { label: 'File', value: CONTENT_TYPES.FILE },
  { label: 'Screenshot', value: CONTENT_TYPES.IMAGE },
];

export const CONTENT_TYPE_LABELS: Record<ContentType, string> = {
  [CONTENT_TYPES.VIDEO]: 'Video',
  [CONTENT_TYPES.FILE]: 'File',
  [CONTENT_TYPES.IMAGE]: 'Screenshot',
};

export const REQUEST_CONTENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  EXPIRED: 'expired',
} as const;

export const BACKEND_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
} as const;

export const EXPIRATION_OPTIONS = REQUEST_EXPIRATION_OPTIONS;
export const EXPIRATION_OPTION_HOURS = REQUEST_EXPIRATION_OPTION_HOURS;

export const COLLECTION_SELECTION = {
  AUTO: 'auto',
  PICK: 'pick',
  MANUAL: 'manual',
} as const;

export type CollectionSelection = (typeof COLLECTION_SELECTION)[keyof typeof COLLECTION_SELECTION];

export type RequestContentStatus = (typeof REQUEST_CONTENT_STATUS)[keyof typeof REQUEST_CONTENT_STATUS];

export const computeStatus = (backendStatus: any, expiresAt?: string): RequestContentStatus => {
  if (expiresAt && new Date() > new Date(expiresAt)) {
    return REQUEST_CONTENT_STATUS.EXPIRED;
  }
  // Handle different backend status formats: boolean, number, or string
  const isActive = backendStatus === true || backendStatus === 1 || backendStatus === '1' || backendStatus === 'active';
  return isActive ? REQUEST_CONTENT_STATUS.ACTIVE : REQUEST_CONTENT_STATUS.INACTIVE;
};

export const getBackendStatus = (status: RequestContentStatus): number => {
  return status === REQUEST_CONTENT_STATUS.ACTIVE ? BACKEND_STATUS.ACTIVE : BACKEND_STATUS.INACTIVE;
};

// Modal view constants
export const MODAL_VIEWS = {
  FORM: 'FORM',
  SUCCESS: 'SUCCESS',
  EDIT_URL: 'EDIT_URL',
} as const;

export type ModalView = (typeof MODAL_VIEWS)[keyof typeof MODAL_VIEWS];

// Modal titles
export const MODAL_TITLES = {
  CREATE_REQUEST_LINK: 'Create Request Link',
  EDIT_REQUEST_LINK: 'Edit Request Link',
} as const;

// Slide animation classes
export const SLIDE_CLASSES = {
  SUCCESS: 'slide-success',
  EDIT_URL: 'slide-edit-url',
  COLLECTION: 'slide-collection',
} as const;
